import { produce } from "immer";


const chatReducer = (
    state = {
        loading: false,
        chats: null,
        currentChat: null,
        loading_send_message: false,
        loading_set_chat_read: false
    },
    action
) => {
    switch (action.type) {
        case 'SET_CURRENT_CHAT':
            state = {
                ...state,
                currentChat: action.payload
            }
            break;
        case 'GET_CHATS_REQUEST':
            state = {
                ...state,
                loading: true
            }
            break;
        case 'GET_CHATS_SUCCESS':
            state = {
                ...state,
                chats: action.payload,
                loading: false
            }
            break;
        case 'GET_CHATS_FAILURE':
            state = {
                ...state,
                loading: false
            }
            break;
        case 'SEND_MESSAGE_REQUEST':
            state = {
                ...state,
                loading_send_message: true
            }
            break;
        case 'SEND_MESSAGE_SUCCESS':
            return produce(state, (draft) => {
                draft.currentChat.messages.push(action.payload);

                const currIndex = draft.chats.findIndex(chat => chat.id === draft.currentChat.id);
                if (currIndex !== -1) {
                    draft.chats[currIndex].messages = [
                        ...draft.chats[currIndex].messages,
                        action.payload
                    ]
                }
            })
        case 'ADD_NEW_MESSAGE_TO_CHAT':
            return produce(state, (draft) => {
                draft.currentChat.messages.push(action.payload);

                const currIndex = draft.chats.findIndex(chat => chat.id === draft.currentChat.id);
                if (currIndex !== -1) {
                    draft.chats[currIndex].messages = [
                        ...draft.chats[currIndex].messages,
                        action.payload
                    ]
                }
            })
        case 'SEND_MESSAGE_FAILURE':
            state = {
                ...state,
                loading_send_message: false
            }
            break;
        case 'SET_CHAT_READ_REQUEST':
            state = {
                ...state,
                loading_set_chat_read: true
            }
            break;
        case 'SET_CHAT_READ_SUCCESS':
            return produce(state, (draft) => {
                const currIndex = draft.chats.findIndex(chat => chat.id === draft.currentChat.id);
                if (currIndex !== -1) {
                    draft.chats[currIndex].read = true;
                    draft.chats[currIndex].messages.forEach(message => {
                        message.read = true;
                    })
                }
            })
        case 'SET_CHAT_READ_FAILURE':
            state = {
                ...state,
                loading_set_chat_read: false
            }
            break;
        case 'CREATE_CHAT_REQUEST':
            state = {
                ...state,
                loading_create_chat: true
            }
            break;
        case 'CREATE_CHAT_SUCCESS':
            state = {
                ...state,
                chats: [...(state.chats || []), action.payload],
                loading_create_chat: false
            }
            break;
        case 'CREATE_CHAT_FAILURE':
            state = {
                ...state,
                loading_create_chat: false
            }
            break;
        case 'GET_CHATS_UNREAD_COUNT_REQUEST':
            state = {
                ...state,
                loading_get_chats_unread_count: true
            }
            break;
        case 'GET_CHATS_UNREAD_COUNT_SUCCESS':
            state = {
                ...state,
                unread_chats_count: action.payload?.total_unread,
                loading_get_chats_unread_count: false
            }
            break;
        case 'GET_CHATS_UNREAD_COUNT_FAILURE':
            state = {
                ...state,
                loading_get_chats_unread_count: false
            }
            break;
        // New cases for real-time message updates
        case 'RECEIVE_MESSAGE':
            return produce(state, (draft) => {
                const message = action.payload;
                const chatId = message.chat_id;

                // Update current chat if it matches
                if (draft.currentChat && draft.currentChat.id === chatId) {
                    // Check if message already exists to avoid duplicates
                    const messageExists = draft.currentChat.messages.some(m => m.id === message.id);
                    if (!messageExists) {
                        draft.currentChat.messages.push(message);
                    }
                }

                // Update chats list
                const chatIndex = draft.chats?.findIndex(chat => chat.id === chatId);
                if (chatIndex !== -1 && draft.chats) {
                    const messageExists = draft.chats[chatIndex].messages.some(m => m.id === message.id);
                    if (!messageExists) {
                        draft.chats[chatIndex].messages.push(message);
                        // Mark as unread if not the current chat
                        if (!draft.currentChat || draft.currentChat.id !== chatId) {
                            draft.chats[chatIndex].read = false;
                        }
                    }
                }
            });
        case 'UPDATE_CHAT_WITH_NEW_MESSAGE':
            return produce(state, (draft) => {
                const { chatId, message } = action.payload;

                // Update current chat if it matches
                if (draft.currentChat && draft.currentChat.id === chatId) {
                    const messageExists = draft.currentChat.messages.some(m => m.id === message.id);
                    if (!messageExists) {
                        draft.currentChat.messages.push(message);
                    }
                }

                // Update chats list
                const chatIndex = draft.chats?.findIndex(chat => chat.id === chatId);
                if (chatIndex !== -1 && draft.chats) {
                    const messageExists = draft.chats[chatIndex].messages.some(m => m.id === message.id);
                    if (!messageExists) {
                        draft.chats[chatIndex].messages.push(message);
                        // Mark as unread if not the current chat
                        if (!draft.currentChat || draft.currentChat.id !== chatId) {
                            draft.chats[chatIndex].read = false;
                        }
                    }
                }
            });
        case 'REFRESH_CHAT_MESSAGES_REQUEST':
            state = {
                ...state,
                loading_refresh_messages: true
            }
            break;
        case 'REFRESH_CHAT_MESSAGES_SUCCESS':
            return produce(state, (draft) => {
                const { chatId, messages } = action.payload;

                // Update current chat if it matches
                if (draft.currentChat && draft.currentChat.id === chatId) {
                    draft.currentChat.messages = messages;
                }

                // Update chats list
                const chatIndex = draft.chats?.findIndex(chat => chat.id === chatId);
                if (chatIndex !== -1 && draft.chats) {
                    draft.chats[chatIndex].messages = messages;
                }

                draft.loading_refresh_messages = false;
            });
        case 'REFRESH_CHAT_MESSAGES_FAILURE':
            state = {
                ...state,
                loading_refresh_messages: false
            }
            break;
    }
    return state;
};

export default chatReducer;

